import { Component } from '@theme/component';

/**
 * Header actions wrapper (account, etc.).
 *
 * @extends {Component}
 */
class HeaderActions extends Component {}

if (!customElements.get('header-actions')) {
  customElements.define('header-actions', HeaderActions);
}
